import applicationFormService from '../../services/applicationForm.service';
import { AcknowledgeLeaseTermsInput, AcknowledgeLeaseTermsResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { NetworkError } from '../../state-machine/actions/genericActions';

const acknowledgeLeaseOptions = async (context: any, event: any): Promise<AcknowledgeLeaseTermsResponse | undefined> => {
  try {
    const input: AcknowledgeLeaseTermsInput = {
      applicationId: context.application?.lease?.id,
      isAcknowledged: false,
    };

    const { data } = await applicationFormService.acknowledgeLeaseOptions(input);
    return data?.acknowledgeLeaseTerms as AcknowledgeLeaseTermsResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default acknowledgeLeaseOptions;
